import { Controller } from 'stimulus';
import Rails from 'rails-ujs';

export default class extends Controller {
  static targets = [ 'checkBox', 'checkBoxRequieAvailable', 'checkBoxFeesFreeDisplay' ]

  onCheck() {
    if (this.checkBoxTarget.checked){
      if (confirm('プロフィールを公開してよろしいですか？')){
        this.upDatePublishProfile()
      } else {
        this.checkBoxTarget.checked = false
      }
    } else {
      if (confirm('プロフィールを非公開にしてよろしいですか？')){
        this.upDatePublishProfile()
      } else {
        this.checkBoxTarget.checked = true
      }
    }
  }

  upDatePublishProfile(){
    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/admin_realtors/${ this.checkBoxTarget.defaultValue }/update_publish_profile?publish_profile=${ this.checkBoxTarget.checked }`,
      success: (json) => {
        if (json.publish_profile) {
          alert('プロフィールを公開しました')
        } else {
          alert('プロフィールを非公開にしました')
        }
      },
      error: () => {
        alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。')
      }
    })
  }

  onCheckRequieAvailable() {
    if (this.checkBoxRequieAvailableTarget.checked){
      if (confirm('りくいえの利用を許可しますか？')){
        this.updateRequieAvailable()
      } else {
        this.checkBoxRequieAvailableTarget.checked = false
      }
    } else {
      if (confirm('りくいえの利用を停止しますか？')){
        this.updateRequieAvailable()
      } else {
        this.checkBoxRequieAvailableTarget.checked = true
      }
    }
  }

  updateRequieAvailable(){
    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/admin_realtors/${ this.checkBoxRequieAvailableTarget.defaultValue }/update_requie_available?requie_available=${ this.checkBoxRequieAvailableTarget.checked }`,
      success: (json) => {
        if (json.requie_available) {
          alert('りくいえの利用を許可しました')
        } else {
          alert('りくいえの利用を停止しました')
        }
      },
      error: () => {
        alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。')
      }
    })
  }

  onCheckFeesFreeDisplay() {
    if (this.checkBoxFeesFreeDisplayTarget.checked){
      if (confirm('手数料無料表記を表示しますか？')){
        this.updateFeesFreeDisplay()
      } else {
        this.checkBoxFeesFreeDisplayTarget.checked = false
      }
    } else {
      if (confirm('手数料無料表記を非表示にしますか？')){
        this.updateFeesFreeDisplay()
      } else {
        this.checkBoxFeesFreeDisplayTarget.checked = true
      }
    }
  }

  updateFeesFreeDisplay(){
    Rails.ajax({
      type: 'PATCH',
      dataType: 'json',
      url: `/api/admin_realtors/${ this.checkBoxFeesFreeDisplayTarget.defaultValue }/update_fees_free_display?fees_free_display=${ this.checkBoxFeesFreeDisplayTarget.checked }`,
      success: (json) => {
        if (json.fees_free_display) {
          alert('手数料無料表記を表示しました')
        } else {
          alert('手数料無料表記を非表示にしました')
        }
      },
      error: () => {
        alert('エラーが発生しました。ブラウザをリロードして、再度お試しください。')
      }
    })
  }
}
